import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfermaComponent } from './conferma/conferma.component';
import {RouterModule} from "@angular/router";


export const routes = [
  {
    path: 'confirm/:pagetype',
    component: ConfermaComponent,
  }
];
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],declarations: [
    ConfermaComponent
  ],
})
export class ConfirmationModule { }
